<template>
  <div class="qrcode-container">
    <img src="../assets/images/qrcode.jpg"/>
    <p v-text="text"></p>
  </div>
</template>

<script>
export default {
  props: ['sectionsIndex',"text"]
}
</script>

<style lang="scss" scoped>
</style>
